import { useMutation, useQueryClient } from '@tanstack/react-query';
import { findActionIn, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
export function useEditAgent() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ agent, edits }) => {
            if (!user)
                throw new Error('not authenticated');
            const action = findActionIn(agent.potentialAction, 'edit');
            if (!action)
                throw new Error('edit action unavailable for this agent');
            if (!agent.id)
                throw new Error('agent.id missing');
            const body = {
                object: agent.id,
            };
            if (edits.name !== undefined)
                body.name = edits.name;
            if (edits.whatsAppE164 !== undefined)
                body.whatsAppE164 = edits.whatsAppE164;
            if (edits.adminNotes !== undefined)
                body.adminNotes = edits.adminNotes;
            if (edits.status !== undefined)
                body.status = edits.status;
            const response = await invokeAction(action, user.token, { body });
            if (!response.ok)
                throw new Error(`editAgent returned ${response.status}`);
            const json = (await response.json());
            const updated = json.object;
            if (!updated)
                throw new Error('editAgent response missing object');
            return updated;
        },
        onSuccess: (updated) => {
            const uuid = updated.UUID;
            if (uuid && user?.email) {
                queryClient.setQueryData(['getAgent', user.email, uuid], updated);
            }
            void queryClient.invalidateQueries({ queryKey: ['listAgents', user?.email] });
        },
    });
}
